import _ from 'lodash'
import React from 'react'
import { useIntl } from 'react-intl'
import { Box, useTheme } from '@mui/material'

const ExamNavigation = ({ questions, studentAnswers }) => {
    const theme = useTheme()
    const { formatMessage } = useIntl()

    const styles = {
        wrapper: {
            border: `1px solid ${theme.palette.grey[200]}`,
            mb: 2,
            p: 2,
            borderRadius: '8px',
            overflow: 'hidden',

            '@media screen and (max-width: 500px)': {
                p: 0,
                border: 'none',
            },
        },
        answered: {
            mb: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 500,
        },
        questions: {
            display: 'grid',
            gridTemplateColumns: 'repeat(5, auto)',
            alignItems: 'start',
            justifyContent: 'space-between',

            '@media screen and (max-width: 500px)': {
                gridTemplateColumns: `repeat(${questions?.length}, auto)`,
                width: '100%',
                overflow: 'auto',
                pb: 1,
            },
        },
        question: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            width: '40px',
            height: '40px',

            mb: 1,
            borderRadius: '4px',
            // background: theme.palette.grey[100],
            cursor: 'pointer',

            '&:hover': {
                background: theme.palette.grey[200],
            },

            '@media screen and (max-width: 500px)': {
                mr: 1,
            },
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.answered}>
                {formatMessage({ id: 'answeredQuestions' })}:
                <Box>
                    {studentAnswers?.length}/{questions?.length}
                </Box>
            </Box>

            <Box sx={styles.questions}>
                {questions.map((question, index) => {
                    const isAnswered = _.some(
                        studentAnswers,
                        (answer) => answer.questionId == question.id,
                    )
                    return (
                        <Box
                            key={question.id}
                            sx={{
                                ...styles.question,
                                background: isAnswered
                                    ? theme.palette.primary.main
                                    : theme.palette.grey[100],
                                color: isAnswered ? '#fff' : 'inherit',
                            }}
                        >
                            {index + 1}
                        </Box>
                    )
                })}
            </Box>
        </Box>
    )
}

export default ExamNavigation
